module.exports = __webpack_public_path__ + "static/media/icon-t3.6b7eabd3.png";